<div class="scroll-to-top" [ngClass]="{'show-scrollTop': windowScrolled}">
  <button type="button" class="btn btn-dark btn-circle btn-md active" data-toggle="button" aria-pressed="true" (click)="scrollToTop()">
      <i class="fas fa-chevron-up" ></i>
  </button>
</div>
